import { styled } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import Box from './Box'
import GrooverText from './GrooverText'

const CourseRegistrationApprovalWaiting = () => (
  <ApprovalContainer align="center" fullWidth>
    <CheckCircleWrapper>
      <CheckCircleIcon sx={{ fontSize: 50, color: '#129230', background: '#eafbee', borderRadius: '50%' }} />
    </CheckCircleWrapper>
    <ApprovalTitle>
      <GrooverText textKey="registrationApprovalTitle" />
    </ApprovalTitle>
    <ApprovalInfoBox>
      <ApprovalInfoMain>
        <GrooverText textKey="registrationApprovalInfoMain" />
      </ApprovalInfoMain>
      <ApprovalInfoSub>
        <GrooverText textKey="registrationApprovalInfoSub" />
      </ApprovalInfoSub>
    </ApprovalInfoBox>
    <NextStepBox>
      <NextStepTitle>
        <GrooverText textKey="registrationApprovalNextStepTitle" />
      </NextStepTitle>
      <NextStepSub>
        <GrooverText textKey="registrationApprovalNextStepSub" />
      </NextStepSub>
    </NextStepBox>
  </ApprovalContainer>
)

const ApprovalContainer = styled(Box)``

const CheckCircleWrapper = styled(Box)``

const ApprovalTitle = styled('h2')`
  font-size: 1.6rem;
  font-weight: 700;
  color: #181c32;
`

const ApprovalInfoBox = styled(Box)`
  background: #f1fdf5;
  border: 1px solid #b6f2d0;
  border-radius: 16px;
  padding: 32px 24px;
  width: 100%;
  max-width: 700px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const ApprovalInfoMain = styled('div')`
  font-size: 1.5rem;
  font-weight: 600;
  color: #129230;
  margin-bottom: 8px;
  text-align: center;
`

const ApprovalInfoSub = styled('div')`
  font-size: 1.1rem;
  color: #129230;
  text-align: center;
`

const NextStepBox = styled(Box)`
  margin-top: 16px;
  text-align: center;
`

const NextStepTitle = styled('div')`
  font-size: 1.1rem;
  font-weight: 600;
  color: #6b7280;
  margin-bottom: 4px;
`

const NextStepSub = styled('div')`
  font-size: 1rem;
  color: #6b7280;
`

export default CourseRegistrationApprovalWaiting
